module.exports = __webpack_public_path__ + "img/lasource-32.251073a5.jpg";